import React, { useState, useEffect } from "react";

import Resizer from "react-image-file-resizer";
import { useMutation, gql } from "@apollo/client";

import axios from "axios";
import { server } from "../../../utills/utils";

import Product from "./Product";
import Modal from "../../Modals/ProductModal";
import EditModal from "../../Modals/ProductModal";
import Spinner from "../../Modals/SpinnerModal";
import Upload from "../../../assets/upload.png";
import EditProduct from "./EditProduct";

import styled from "styled-components";
import "./products.css";
import { faHospitalUser } from "@fortawesome/free-solid-svg-icons";

const UPLOAD_FILE = gql`
  mutation uploadToAws($file: Upload!) {
    uploadToAws(file: $file) {
      url
    }
  }
`;

const Container = styled.div`
  width: 100%;
  height: 85vh;
`;
const AllProducts = styled.div`
  width: 103%;
  height: 86%;
  margin-top: 10px;
  overflow-y: scroll;
  display: flex;
  flex-flow: wrap;
  flex-direction: row;
  align-content: flex-start;
`;
const InputBox = styled.div`
  width: 100%;
  height: auto;
  margin-bottom: 10px;
`;
const Input = styled.input`
  width: 100%;
  border: none;
  outline: none;
  padding: 20px 0 5px 0;
  font-size: 1.1em;
  border-bottom: 2px solid #ccc;
`;
const Input1 = styled.input`
  width: 45%;
  border: none;
  outline: none;
  padding: 20px 0 5px 0;
  font-size: 1.1em;
  border-bottom: 2px solid #ccc;
  float: left;
`;
const Input2 = styled.input`
  width: 45%;
  border: none;
  outline: none;
  padding: 20px 0 5px 0;
  font-size: 1.1em;
  border-bottom: 2px solid #ccc;
  float: right;
`;
const Description = styled.textarea`
  width: 97.5%;
  height: 200px;
  border: none;
  outline: none;
  padding: 1%;
  font-size: 1.1em;
  border: 1px solid #ccc;
  margin: 10px 0;
  resize: none;
  font: inherit;
  border-radius: 5px;
`;
const InputFile = styled.input`
  &{
    width: 98.5%;
    border: none;
    outline: none;
    padding: 20px 0 5px 0;
    font-size: 1.1em;
    color rde;
  }
  &::-webkit-visibility {
   hidden
}
  &before{
    content: 'Select some files';
  color: black;
  display: inline-block;
  background: -webkit-linear-gradient(top, #f9f9f9, #e3e3e3);
  border: 1px solid #999;
  border-radius: 3px;
  padding: 5px 8px;
  outline: none;
  white-space: nowrap;
  -webkit-user-select: none;
  cursor: pointer;
  text-shadow: 1px 1px #fff;
  font-weight: 700;
  font-size: 10pt;
  }
`;

const Button = styled.button`
  width: 100%;
  padding: 13px 10px;
  background: #f97a7a;
  color: white;
  font-size: 1.1em;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin: 20px 0;
`;
const Header = styled.div`
  width: 100%;
  height: 50px;
`;
const HeaderTitle = styled.h2`
  float: left;
  margin: 0;
  padding: 0;
  font-weight: 500;
`;

const AddNewButton = styled.button`
  float: right;
  padding: 10px 20px;
  background: #f97a7a;
  color: white;
  font-size: 0.9em;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin: 5px 0;
`;

const ImageView = styled.div`
  width: 100%;
  height: 200px;
`;
const UploadButton = styled.div`
  width: 20%;
  margin-left: 40%;
  text-align: center;
  padding-top: 40px;
  cursor: pointer;
`;
const ImagePreview = styled.div`
  width: 35%;
  height: 100%;
  background: #f8f8f8;
  float: right;
  text-align: center;
  border-radius: 5px;
  overflow: hidden;
`;
const AddTitele = styled.h4`
  margin: 0;
  padding: 0;
  font-size: 1.2em;
  font-weight: 500;
  color: #f97a7a;
`;
const ImageBox2 = styled.div`
  width: 23%;
  padding: 20px 0;
  background: rgb(180, 177, 177);
  text-align: center;
  border-radius: 5px;
`;
const ImageBox = styled.div`
  width: 23%;
  height: 140px;
  background: rgb(180, 177, 177);
  @keyframes mymove {
    from {
      background-color: #e6e1e1;
    }
    to {
      background-color: #c7caca;
    }
  }
  animation: mymove 1s infinite;
  margin: 0 2% 2% 0;
  border-radius: 5px;
  @media (max-width: 789px) {
    width: 45%;
    height: 150px;
  }
`;
const Image = styled.img`
  width: 22.5%;
  height: 140px;
  margin: 0 2% 2% 0;
  border-radius: 5px;
  border: 1px solid #ccc;
  @media (max-width: 789px) {
    width: 45%;
    height: 150px;
  }
`;
function Products() {
  let imageBoxes = [];
  const [products, setProducts] = useState([]);
  const [complete, setComplete] = useState(false);
  const [name, setName] = useState("");
  const [price, setPrice] = useState(null);
  const [measure, setMeasure] = useState("");
  const [categoryName, setCategoryName] = useState("");
  const [categoryId, setCategoryId] = useState(null);
  const [subCatId, setSubCatId] = useState(null);
  const [subId, setSubId] = useState(null);
  const [brandName, setBrandName] = useState("");
  const [brandId, setBrandId] = useState(null);
  const [addProductModal, setAddProductModal] = useState(false);
  const [uploadDone, setUploadDone] = useState(false);
  const [productImage, setProductImage] = useState("");
  const [spinner, setSpinner] = useState(false);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubcats] = useState([]);
  const [imageUpload, setUpload] = useState(false);
  const [images, setImages] = useState([]);
  const [totalImages, setTotalImages] = useState(0);
  const [description, setDescription] = useState("");
  const [editProduct, setEditProduct] = useState(false);
  const [editProductValues, setValues] = useState({});
  const [updatedIndex, setUpdatedIndex] = useState();

  const nameChangeHandler = (e) => {
    setName(e.target.value);
  };
  const priceChangeHandler = (e) => {
    setPrice(e.target.value);
  };
  const descriptionHandler = (e) => {
    setDescription(e.target.value);
  };
  const categoryChangeHandler = (e) => {
    let index = e.target.value;
    setCategoryId(index);
    setSubcats(categories[index].subCategories);
  };

  const SubCatChangeHandler = (e) => {
    setSubCatId(e.target.value);
  };
  const brandChangeHandler = (e) => {
    setBrandName(e.target.value);
  };
  const measureChangeHandler = (e) => {
    setMeasure(e.target.value);
  };

  const editProductModalHandler = (index) => {
    if (editProduct) {
      setEditProduct(false);
    } else {
      setEditProduct(true);
      console.log("Index", products[index]);
      setValues(products[index]);
      setUpdatedIndex(index);
    }
  };
  const resizeFile = (file) =>
    new Promise(async (resolve) => {
      await Resizer.imageFileResizer(
        file,
        1400,
        1200,
        "WEBP",
        100,
        0,
        (uri) => {
          // resolve(uri);
          console.log("UK uri", uri);
          const file = uri;
          console.log("UK uri 1", file);
          uploadToAws({ variables: { file } });
        },
        "file"
      );
    });

  const handleFileChange = async (e) => {
    setUpload(true);
    setSpinner(true);
    const files = e.target.files;
    setTotalImages(e.target.files.length);
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      resizeFile(file);
      console.log("resize", file);
      setEditProduct(false);
      //uploadToAws({ variables: { file } });
    }
    setTimeout(() => {
      setSpinner(false);
    }, 5000);
  };
  for (let i = 0; i < totalImages; i++) {
    imageBoxes.push(<ImageBox />);
  }
  const productUpdateHandler = async (product) => {
    // e.preventDefault();
    try {
      setSpinner(true);

      product.productId = product._id;
      product.images = JSON.stringify(product.images).replace(
        /"([^(")"]+)":/g,
        "$1:"
      );
      console.log("Product updated", product);
      await axios
        .post(server, {
          query: `
           mutation{
             updateProduct(input:{
                productId:"${product._id}"
                name:"${product.name}",
                price:${product.price},
                measurment:"${product.measurment}",
                brandName:"${product.brandName}",
                images:${product.images},
                description:"${product.description}"
             }){
              _id
              name
              price
              measurment
              images
             }
           }
        `,
        })
        .then((res) => {
          console.log("Updated res", res.data.data.updateProduct);
          const allProducts = products;
          allProducts[updatedIndex] = res.data.data.updateProduct;
          setProducts(allProducts);
          setSpinner(false);
          setEditProduct(false);
        });
    } catch (error) {
      setSpinner(false);
      console.log("Error", error);
    }
  };
  //Image upload
  const [uploadToAws] = useMutation(UPLOAD_FILE, {
    onCompleted: (data) => {
      console.log(data);
      setProductImage(data.uploadToAws.url);
      setUploadDone(true);
      const newImages = images;
      newImages.push(data.uploadToAws.url);
      setImages(newImages);
      console.log("images", newImages);
      setTotalImages(totalImages - 1);
    },
  });
  // function krEncodeEntities(s){
  //   return $j("<div/>").text(s).html();
  // }
  // function krDencodeEntities(s){
  //   return $j("<div/>").html(s).text();
  // }

  const fetchProducts = async () => {
    try {
      const products = await axios.post(server, {
        query: `
                      query{
                          products{
                              _id
                              name
                              price
                              measurment
                              images
                              categoryName
                              categoryId
                              categoryName
                              subCategoryId
                              subCategoryName
                              
                          }
                      }
                    `,
      });
      setProducts(products.data.data.products);
      setComplete(true);
      console.log(products.data.data.products);
    } catch (error) {
      throw error;
    }
  };

  const addProductModalHandler = () => {
    setAddProductModal(!addProductModal);
  };

  const fetchCategories = async () => {
    try {
      const fetchCategories = await axios.post(server, {
        query: `
           query{
            allCategories{
              _id
              name
              subCategories{
                _id
                name
              }
            }
           }
          
          `,
      });
      const data = fetchCategories.data.data.allCategories;
      setCategories(data);
    } catch (error) {
      throw error;
    }
  };
  console.log(subCategories);
  const addProductHandler = async (e) => {
    try {
      e.preventDefault();
      setAddProductModal(false);
      setSpinner(true);
      console.log(
        name,
        price,
        categories[categoryId]._id,
        subCategories[subCatId]._id,
        measure,
        brandName,
        images
      );
      const product = await axios.post(server, {
        query: `
              mutation{
                addProduct(
                  input:{
                    name:"${name}",
                    price:${price},
                    categoryId:"${categories[categoryId]._id}",
                    categoryName:"${categories[categoryId].name}",
                    subCategoryId:"${subCategories[subCatId]._id}",
                    subCategoryName:"${subCategories[subCatId].name}",
                    measurment:"${measure}",
                    brandName:"${brandName}",
                    images:${JSON.stringify(images).replace(
                      /"([^(")"]+)":/g,
                      "$1:"
                    )},
                    description:"${description}"
                  }
                ){
                  _id
                  name
                  price
                  measurment
                  images
                }
              }
           `,
      });
      setProducts(product.data.data.addProduct);
      setName("");
      setPrice("");
      setImages([]);
      setUpload(false);
      setDescription("");
      setMeasure("");
      setProductImage("");
      setSpinner(false);
    } catch (error) {
      throw error;
    }
  };
  useEffect(() => {
    fetchProducts();
    fetchCategories();
  }, []);

  return (
    <Container>
      <Spinner show={spinner} />
      <EditModal show={editProduct} closeModal={editProductModalHandler}>
        <EditProduct
          productUpdateHandler={productUpdateHandler}
          product={editProductValues}
        />
      </EditModal>
      <Modal show={addProductModal} closeModal={addProductModalHandler}>
        <div style={{ padding: "2%" }}>
          <AddTitele>Add product</AddTitele>
          <form onSubmit={addProductHandler}>
            {!imageUpload ? (
              <ImageView>
                <UploadButton>
                  <label for="file-input">
                    <img
                      style={{ width: "70px", height: "70px" }}
                      src={Upload}
                    />
                  </label>
                  <input
                    id="file-input"
                    className="custom-file-input"
                    required="true"
                    type="file"
                    multiple
                    onChange={handleFileChange}
                    accept="image/x-png,image/gif,image/jpeg"
                  />
                </UploadButton>
                {/* <ImagePreview>
                  {uploadDone ? (
                    <img
                      style={{ width: "100%", height: "100%" }}
                      src={productImage}
                      alt="productimage"
                    />
                  ) : null}
                </ImagePreview> */}
              </ImageView>
            ) : (
              <div
                style={{
                  width: "103%",
                  display: "flex",
                  margin: "20px 0",
                  flexFlow: "wrap",
                  height: "auto",
                  flexDirection: "row",
                }}
              >
                {images.map((img) => (
                  <Image src={img} />
                ))}
                {imageBoxes}
              </div>
            )}

            <Input
              value={name}
              onChange={nameChangeHandler}
              required="true"
              type="text"
              placeholder="Product name"
            />

            <InputBox>
              <Input1
                value={measure}
                onChange={measureChangeHandler}
                required="true"
                type="text"
                placeholder="Measurement"
              />
              <Input2
                onChange={priceChangeHandler}
                value={price}
                required="true"
                type="number"
                min="0"
                placeholder="Product price"
              />
            </InputBox>

            <select
              className="Category"
              required="true"
              onChange={categoryChangeHandler}
            >
              <option value="">Select Category </option>
              {categories.map((category, id) => {
                return <option value={id}>{category.name}</option>;
              })}
            </select>
            <select
              className="Brand"
              required="true"
              onChange={SubCatChangeHandler}
            >
              <option value="">Select Subcategory</option>
              {subCategories.map((sub, id) => {
                return <option value={id}>{sub.name}</option>;
              })}
            </select>
            <Input
              value={brandName}
              onChange={brandChangeHandler}
              required="true"
              type="text"
              placeholder="Brand name"
            />

            <Description
              value={description}
              onChange={descriptionHandler}
              type="text"
              name={description}
              placeholder="Description"
            />

            <Button type="submit">Add</Button>
          </form>
        </div>
      </Modal>
      <Header>
        <HeaderTitle>Products</HeaderTitle>
        <AddNewButton onClick={addProductModalHandler}>
          Add new product
        </AddNewButton>
      </Header>
      <AllProducts>
        {complete ? (
          products.map((product, id) => {
            return (
              <Product
                index={id}
                product={product}
                editHandler={editProductModalHandler}
              />
            );
          })
        ) : (
          <p>Loading...</p>
        )}
      </AllProducts>
    </Container>
  );
}

export default Products;
